import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtmTextH6Component } from './atm-text-h6.component';

@NgModule({
  declarations: [AtmTextH6Component],
  imports: [CommonModule],
  exports: [AtmTextH6Component],
})
export class AtmTextH6Module {}
